export const RESET_CURRENT_USER = 'RESET_CURRENT_USER'
export const BOOTSTRAP_CURRENT_USER = 'BOOTSTRAP_CURRENT_USER'
export const UPDATE_CURRENT_USER = 'UPDATE_CURRENT_USER'
export const ADD_USER = 'ADD_USER'
export const ADD_USERS = 'ADD_USERS'
export const COMPANY_INFO = 'COMPANY_INFO'
export const SET_CURRENT_SHOP = 'SET_CURRENT_SHOP'

